import { DefaultService } from '@/services/DefaultService';

export default class RegrasDescontoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }
    
    find(id) {
        return this._http.get(encodeURI(`${this._env}/vendas/politica-comercial/regras-desconto/${id}.json`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(column, order,page = 0, limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/vendas/politica-comercial/regras-desconto.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(obj) {
        return this._http.post(`${this._env}/vendas/politica-comercial/regras-desconto/update-situacao`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    save(obj){
        return this._http.post(`${this._env}/vendas/politica-comercial/regras-desconto/save`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}